import Icon from 'vue-awesome/components/Icon'

Icon.register({
  directions_walk_rounded: {
    paths: [
      {
        d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7.24 21.81c-.13.61.35 1.19.98 1.19h.08c.47 0 .87-.32.98-.78L10.9 15l2.1 2v5c0 .55.45 1 1 1s1-.45 1-1v-5.64c0-.55-.22-1.07-.62-1.45L12.9 13.5l.6-3a7.321 7.321 0 004.36 2.41c.6.09 1.14-.39 1.14-1 0-.49-.36-.9-.85-.98-1.52-.25-2.78-1.15-3.45-2.33l-1-1.6a2.145 2.145 0 00-2.65-.84L7.22 7.78A2.01 2.01 0 006 9.63V12c0 .55.45 1 1 1s1-.45 1-1V9.6l1.8-.7'
      }
    ],
    width: '24',
    height: '24'
  }
})
